<style scoped lang="scss">
.search-bar{
  display: flex;
  align-items: center;
  padding:10px;
  background: #fff;
  .search-box{
    padding:12px 15px;
    background: #F5F5F5;
    display: flex;
    align-items: center;
    flex:1;
    input{
      flex:1;
    }
  }
  .icon-back{
    width:30px;
    margin-right: 10px;
  }
  .icon-search{
    width:14px;
    margin-right: 10px;
  }
  .btn-search{
    color:#014492;
    font-size: 14px;
    font-weight: bold;
    margin-left: 10px;
  }
}
</style>
<template>
  <div class="search-bar">
    <img src="@/assets/images/mobile/icon_back.png" class="icon-back" @click="$router.go(-1)">
    <div class="search-box">
      <img src="@/assets/images/mobile/icon_search.png" class="icon-search">
      <input placeholder="请输入订单编号" v-model="keywords" @input="bindInput"/>
    </div>
    <span class="btn-search" @click="bindSearch">搜索</span>
  </div>
</template>

<script>
export default {
  name: 'qk-search-bar',
  data () {
    return {
      keywords: '',
      fromPath: ''
    }
  },
  created() {
    const orderNo = localStorage.getItem('searchKeywords')
    console.log(orderNo)
    if (!this.baseMethods.isEmpty(orderNo)) {
      this.keywords = orderNo
    }
  },
  methods: {
    bindSearch () {
      this.$emit('search', this.keywords)
    },
    bindInput () {
      this.$emit('input', this.keywords)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/searchBar.vue